import React from 'react';
import FormularioModificaRemito from '../FormularioModificaRemito';

function EditaRemito() {

    return (
        <div>
            <FormularioModificaRemito tipo={"modificar"}/>            
        </div>
    )
}

export default EditaRemito